import { createTypesenseBrowserSearchClient } from '../typesense/create-browser-typesense-search-client';

export type BrowserSearchClient = ReturnType<typeof createTypesenseBrowserSearchClient>;

/**
 * Returns the configured browser search client (Typesense).
 */
export function createBrowserSearchClient(): BrowserSearchClient | null {
  if (typeof window === 'undefined') return null;

  // Local dev has no local Typesense instance/tunnel — point at the deployed API instead.
  // CORS on /api/* already allows localhost origins for exactly this (see server/utils/cors-api.ts).
  const baseUrl = import.meta.env.DEV ? 'https://www.jobcrawls.com' : undefined;
  return createTypesenseBrowserSearchClient(baseUrl ? { baseUrl } : undefined);
}
